import { Injectable } from "@angular/core";
import { BehaviorSubject,Observable } from "rxjs";
import { LocalStorageProperties } from "../../globaldependencies/constants/localstorage-properties";
import * as _ from "underscore";

export interface SidenavData {
  isSidenavExpanded: boolean,
  isSidenavHovered: boolean
}

export class SidenavUiService {
  isUiExpanded: boolean;
  private _isSidenavExpanded: boolean = false;
  private favouriteCount: BehaviorSubject<number> = new BehaviorSubject<number>(0); 
  private _isSidenavHovered: boolean = false;
  public sidenavChange: BehaviorSubject<SidenavData> = new BehaviorSubject<SidenavData>({
    isSidenavExpanded: false,
    isSidenavHovered: false
  });
 public canTrackKeyStrokesAndMouseMovements : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
 public isSetupPage : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
 keyStrokesTabEnable: boolean;

  constructor(){

    if(window.innerWidth < 1500 ){
      this.isUiExpanded =  false;
      }
      else{
        this.isUiExpanded = true;
      }
      this._isSidenavExpanded = this.isUiExpanded;
      this._isSidenavHovered = this.isUiExpanded;

      this.sidenavChange.next(
        {
          isSidenavExpanded: this.isSidenavExpanded,
          isSidenavHovered: this.isSidenavHovered
        }
      );
      setTimeout(()=>{
       var companySettings = JSON.parse(localStorage.getItem(LocalStorageProperties.CompanySettings));
        this.keyStrokesTabEnable = _.find(companySettings, function (companySetting : any) { return companySetting['key'] == 'CanTrackKeyStrokesAndMouseMovements' }).value  == "0" ? false : true;
        this.canTrackKeyStrokesAndMouseMovements.next(this.keyStrokesTabEnable);
      },500);
  }

  get isSidenavHovered() {
    return this._isSidenavHovered;
  }

  get isSidenavExpanded() {
    return this._isSidenavExpanded;
  }

  set isSidenavExpanded(val: boolean) {
    this._isSidenavExpanded = val;
    this.sidenavChange.next(
      {
        isSidenavExpanded: this.isSidenavExpanded,
        isSidenavHovered: this.isSidenavHovered
      }
    );
  }

  set isSidenavHovered(val: boolean) {
    this._isSidenavHovered = val;
    this.sidenavChange.next(
      {
        isSidenavExpanded: this.isSidenavExpanded,
        isSidenavHovered: this.isSidenavHovered
      }
    );
  }

  /**
   * @name toggleSidenav
   * @description toggle sidenav view to expanded or collapsed
   */
  public toggleSidenav(){
    this.resetMenusState();
    this.isSidenavExpanded = !this.isSidenavExpanded;
    this.removeHoverSidenav();
    setTimeout(() => {
      let sideNav: any = document.querySelector('nav.side-navigation');
      // let extraWidth = sideNav.offsetWidth > 200 ? 44 : 0;
      let extraWidth = 0;
      this.positionHeader(extraWidth);
      this.positionPageContent(extraWidth)
    }, 100);
  }

  /**
   * @name resetMenusState
   * @description reset menu state to collapsed
   */
  private resetMenusState(){
    let allMenus: any = document.querySelectorAll('.menu-title');
    let allMenuPanels: any = document.querySelectorAll('.menu-panel');
    allMenus.forEach((elm) => elm.classList.remove('menu-active'))
    allMenuPanels.forEach((elm) => elm.style.maxHeight = null);
  }

  /**
   * @name positionHeader
   * @description calculate header offset & re-position it
   */
  public positionHeader(extraElmWidth?) {
    // if(this.isSidenavExpanded){
    let header: any = document.querySelector('header.header');
    let sideNav: any = document.querySelector('nav.side-navigation');
    let treeview: any = document.querySelector('.snova-treeview-main-wrapper');
    let leftOffset: number = 1;
    if(sideNav){
      leftOffset += sideNav.offsetWidth;
    }

    //remove if any extra width
    if(extraElmWidth && this.isSidenavExpanded) {
      leftOffset -= extraElmWidth;
    }

    //dont include treeview width for now
    // if(treeview){
    //   leftOffset += treeview.offsetWidth;
    // }

    header.style.marginLeft = leftOffset + 'px';
  // }else
  // {
  //   let header: any = document.querySelector('header.header');
  //   header.style.marginLeft = '70px';
  // }
  }

  /**
   * @name positionPageContent
   * @param extraElmWidth
   */
  public positionPageContent(extraElmWidth?) {
    // if(this.isSidenavExpanded){
    let sideNav: any = document.querySelector('nav.side-navigation');
    let matSidenavContent: any = document.querySelector('.mat-sidenav-content');
    let treeview: any = document.querySelector('.snova-treeview-main-wrapper');
    let leftOffset: number = 1;

    // if(treeview){
    //   leftOffset += treeview.offsetWidth;
    // }

    if(sideNav){
      leftOffset += sideNav.offsetWidth;
    }

    //remove if any extra width
    if(extraElmWidth && this.isSidenavExpanded) {
      leftOffset -= extraElmWidth;
    }

    matSidenavContent.style.marginLeft = leftOffset + 'px';
  // }
  // else{
    
  //   let matSidenavContent: any = document.querySelector('.mat-sidenav-content');
  //   matSidenavContent.style.marginLeft = '70px';
  // }
  }
  getFavouriteCount(){
    return this.favouriteCount.asObservable();
  }
  updateFavouriteCount(newCount: number){
    return this.favouriteCount.next(newCount);
  }
/*
  * @name hoverSidenav
  * @description show hovered sidenav
  */
 hoverSidenav() {
   if(!this.isSidenavExpanded) {
     this.isSidenavHovered = true;
   }
 }

 /**
  * @name removeHoverSidenav
  * @description hide hovered sidenav
  */
 removeHoverSidenav() {
   if(!this.isSidenavExpanded) {
     this.isSidenavHovered = false;
   }
 }
  
 updateKeystrokestab(value: boolean){
  return this.canTrackKeyStrokesAndMouseMovements.next(value);
}

updateSetupPage(value : boolean){
  return this.isSetupPage.next(value)
}

}
